<template>
  <div class="top-bar">
    <span style="color:#fff; font-size:16px">{{ EnvironmentType }}</span>
    <div class="top-bar-right">
      <a-button type="link">帮助文档</a-button>
      <a-popover trigger="click" class="popover-box">
        <template slot="content" class="top-opera-box">
          <ul class="list-operate" @click="handleItemClick">
            <li>账号管理</li>
            <li>切换为园区系统</li>
            <li>切换为企业系统</li>
            <li class="red" @click="handleLogout">退出</li>
          </ul>
        </template>
        <img class="head-pic" :src="headPic" alt="头像" />
        <div>{{ name }}</div>
        <public-uploader v-show="false"></public-uploader>
      </a-popover>
    </div>
  </div>
</template>

<script>
import headPic from "@/assets/head.png";
export default {
  name: "TopBar",
  data() {
    return {
      headPic,
      name: window.sessionStorage.getItem("username")
    };
  },
  props: {
    EnvironmentType: {
      type: String,
      required: false
    }
  },
  methods: {
    handleLogout() {
      this.$router.push("/login");
    },

    handleItemClick({ target }) {
      const { innerText } = target;
      switch (innerText) {
        case "园区信息":
          this.$router.push("/park/info");
          break;
        case "账号管理":
          // let id = this.name
          // this.$router.push(`/system/account/modify-form?id=${id}`)
          break;
        case "切换为园区系统":
          window.location.href = "https://zelo.facebeacon.com";
          break;
        case "切换为企业系统":
          window.location.href = "http://company.zelo.facebeacon.com";
          break;
        default:
          console.log("error click");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.top-bar {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-bar-right {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .popover-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 10px;
      -webkit-user-select: none;
      .head-pic {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        margin-right: 16px;
      }
    }
  }
}
.ant-popover-inner-content {
  padding: 0;
  width: 150px;
}
.red {
  color: red;
}
.list-operate {
  font-size: 14px;
  li {
    padding-left: 12px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background: #f3f3f3;
    }
  }
}
</style>
